/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getKnownFollowers.defs'
export { main as default } from './getKnownFollowers.defs'
